export default __webpack_public_path__ + "static/media/Truly_Logo_Green_svg.717b77b3.svg";